import Client from './client';

export default class FtpSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organizationId, options = {}) {
    return this.makeRequest(`${this.host}/${organizationId}/demandware/ftp-settings`, options);
  }

  post(organizationId, options = {}) {
    return this.makeRequest(`${this.host}/${organizationId}/demandware/ftp-settings`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organizationId, id, options = {}) {
    return this.makeRequest(`${this.host}/${organizationId}/demandware/ftp-settings/${id}`, options);
  }

  putById(organizationId, id, options = {}) {
    return this.makeRequest(`${this.host}/${organizationId}/demandware/ftp-settings/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteById(organizationId, id, options = {}) {
    return this.makeRequest(`${this.host}/${organizationId}/demandware/ftp-settings/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
